<template>
  <div class="footer">
    <div class="my-2">
      <span>
        Copyright © 2025 by LiveABC Interactive Corporation
      </span>
      <span class="pointer disclaimer" target="_blank" @click="goDisclaimer">Disclaimer</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  components: {
  },
  methods: {
    goDisclaimer () {
      this.$router.push({ name: 'Disclaimer' })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .footer {
    width: 100%;
    padding: 15px;
    font-size: 1rem;
    line-height: 1rem;
    color: #fff;
    background-color: #fc5f00;
    border-top: 6px solid #fff;
    z-index: 9999999;
    .disclaimer {
      cursor: pointer;
      text-decoration: underline;
    }
    .help {
      cursor: pointer;
      text-decoration: underline;
    }
  }
</style>
